export enum ReCaptchaV3Action {
  SubmitTrackingWidget = 'submitTrackingWidget',
  TrackingFromPMC = 'trackingFromPmc',
  TrackingFromAMP = 'trackingFromAmp',
  TrackingFromEmail = 'trackingFromEmail',
}
